import React, { useEffect, useState } from "react";
import { Button, Col, Modal, Row, Space } from "antd";
import { useAsyncAxios, utilAxiosFormWithAuth } from "../utils/customAxios";
import RentImageList, { RentImageType } from "./RentImageList";
import RentImageList2, { RentImageType2 } from "./RentImageList2";

import * as Request from "../commons/request";
import * as Types from "../commons/typeDTO";
import * as Strings from "../commons/string";
import * as Utils from "../utils/utils";

function RentImageViewer({
    rent,
    uploader,
    uploadTiming,
    onChangedRent,
}: {
    rent: Types.RentDto;
    uploader: "MANAGER" | "USER";
    uploadTiming: "START" | "END";
    onChangedRent?: () => void;
}) {
    const [resetImages, setResetImages] = useState({});
    const [editModeManagerImage, setEditModeManagerImage] = useState(false);

    const [addImage, setAddImage] = useState<RentImageType>();
    const [additionalImage, setAdditionalImage] = useState<RentImageType2>();

    const checkSaveImages = (images: RentImageType | undefined) => {
        if (images === undefined) return false;

        if (
            images.front === undefined ||
            images.left === undefined ||
            images.back === undefined ||
            images.right === undefined ||
            images.cluster === undefined
        )
            return false;

        return true;
    };

    const requestAxiosAddImages = async (url: string, image: RentImageType, uploader: string) => {
        const response = await utilAxiosFormWithAuth().post(url, image, {
            params: { imageUploader: uploader },
        });

        return response.data;
    };

    const {
        loading: loadingAddImages,
        error: errorAddImages,
        data: resultAddImages,
        execute: requestAddImages,
    } = useAsyncAxios(requestAxiosAddImages);

    useEffect(() => {
        if (resultAddImages === null) return;
        console.log("resultAddImages", resultAddImages);
        onChangedRent && onChangedRent();
    }, [resultAddImages]);

    useEffect(() => {
        if (errorAddImages === null) return;

        console.log("errorAddImages", errorAddImages);
    }, [errorAddImages]);

    const onSaveImage = () => {
        const saveImage = addImage;
        const requestUrl =
            Request.RENT_URL + rent.rentId + (uploadTiming === "START" ? Request.RENT_IMAGE_ADD_START_URL : Request.RENT_IMAGE_ADD_END_URL);
        if (checkSaveImages(saveImage) === false) {
            Utils.addModalStack();
            Modal.error({
                title: "이미지 오류",
                content: "필수 이미지를 넣으세요.",
                okText: "확인",
                onOk() {
                    Utils.popModalStack();
                },
                centered: true,
            });
            return;
        }
        if (saveImage !== undefined && additionalImage !== undefined && additionalImage.rentImages.length > 0) {
            saveImage.additionalImages = additionalImage.rentImages;
        }
        if (saveImage === undefined) return;

        const formData = new FormData();
        saveImage.front && formData.append("front", saveImage.front);
        saveImage.left && formData.append("left", saveImage.left);
        saveImage.back && formData.append("back", saveImage.back);
        saveImage.right && formData.append("right", saveImage.right);
        saveImage.cluster && formData.append("cluster", saveImage.cluster);
        saveImage.additionalImages?.forEach((file) => formData.append("additionalImages", file));

        requestAddImages(requestUrl, formData, uploader);

        // if (type === "START") {

        // } else if (type === "END") {
        //     // saveImage = endManagerImage;
        //     // requestUrl = Request.RENT_URL + currentRent?.rentId + Request.RENT_IMAGE_ADD_END_URL;
        //     // if (saveImage?.rentImages.length === 0) {
        //     //     Modal.error({
        //     //         title: "반납이미지 오류",
        //     //         content: "이미지를 넣으세요.",
        //     //         okText: "확인",
        //     //         onOk() {},
        //     //         centered: true,
        //     //     });
        //     //     return;
        //     // }
        //     // const formData = new FormData();
        //     // endManagerImage?.rentImages.forEach((file) => formData.append("rentImages", file));
        //     // requestAddImages(requestUrl, formData);
        //     saveImage = endManagerImage;
        //     requestUrl = Request.RENT_URL + currentRent?.rentId + Request.RENT_IMAGE_ADD_END_URL;
        //     if (checkSaveImages(saveImage) === false) {
        //         Modal.error({
        //             title: "반납이미지 오류",
        //             content: "필수 이미지를 넣으세요.",
        //             okText: "확인",
        //             onOk() {},
        //             centered: true,
        //         });
        //         return;
        //     }
        //     if (saveImage !== undefined && endManagerAdditionalImage !== undefined && endManagerAdditionalImage.rentImages.length > 0) {
        //         saveImage.additionalImages = endManagerAdditionalImage.rentImages;
        //     }
        //     if (saveImage === undefined) return;
        //     const formData = new FormData();
        //     saveImage.front && formData.append("front", saveImage.front);
        //     saveImage.left && formData.append("left", saveImage.left);
        //     saveImage.back && formData.append("back", saveImage.back);
        //     saveImage.right && formData.append("right", saveImage.right);
        //     saveImage.cluster && formData.append("cluster", saveImage.cluster);
        //     saveImage.additionalImages?.forEach((file) => formData.append("additionalImages", file));
        //     requestAddImages(requestUrl, formData);
        // }
    };

    const onDeleteImage = (rentImageId: number) => {
        Utils.addModalStack();
        Modal.confirm({
            title: "이미지 삭제",
            content: "이미지를 삭제하시겠습니까?",
            okText: "확인",
            onOk() {
                Utils.popModalStack();
                requestDeleteImage(rentImageId);
            },
            cancelText: "취소",
            onCancel() {
                Utils.popModalStack();
                setResetImages({});
            },
            centered: true,
        });
    };

    const requestAxiosDeleteImage = async (rentImageId: number) => {
        const response = await utilAxiosFormWithAuth().delete(Request.RENT_IMAGE_URL + rentImageId);

        return response.data;
    };

    const {
        loading: loadingDeleteImage,
        error: errorDeleteImage,
        data: resultDeleteImage,
        execute: requestDeleteImage,
    } = useAsyncAxios(requestAxiosDeleteImage);

    useEffect(() => {
        if (resultDeleteImage === null) return;
        console.log("resultDeleteImage", resultDeleteImage);
        onChangedRent && onChangedRent();
    }, [resultDeleteImage]);

    useEffect(() => {
        if (errorDeleteImage === null) return;

        console.log("errorDeleteImage", errorDeleteImage);
    }, [errorDeleteImage]);

    return (
        <Space direction="vertical" size={24}>
            <RentImageList
                rentInputImages={rent?.rentImages.filter(
                    (image) => image.imageUploader === uploader && image.uploadTiming === uploadTiming && image.direction !== null
                )}
                inputType={editModeManagerImage}
                resetImage={resetImages}
                onImageListChanged={(imageList) => setAddImage(imageList)}
                onDeleteImage={(rentImageId) => onDeleteImage(rentImageId)}
            />
            {editModeManagerImage && (
                <RentImageList2
                    rentInputImages={rent?.rentImages.filter(
                        (image) => image.imageUploader === uploader && image.uploadTiming === uploadTiming && image.direction === null
                    )}
                    inputType={editModeManagerImage}
                    resetImage={resetImages}
                    onImageListChanged={(imageList) => {
                        const images: RentImageType2 = { rentImages: [] };
                        imageList.forEach((image) => image.file && images.rentImages.push(image.file));
                        setAdditionalImage(images);
                    }}
                    onDeleteImage={(rentImageId) => onDeleteImage(rentImageId)}
                />
            )}
            <Row style={{ width: "100%" }}>
                {editModeManagerImage ? (
                    <Row gutter={10} style={{ width: "100%" }}>
                        <Col span={12} className="row-gutter" style={{ paddingLeft: 0 }}>
                            <Button
                                style={{ width: "100%" }}
                                onClick={() => {
                                    setResetImages({});
                                    setEditModeManagerImage(false);
                                }}
                            >
                                {Strings.prev}
                            </Button>
                        </Col>
                        <Col span={12} className="row-gutter" style={{ paddingRight: 0 }}>
                            <Button
                                style={{ width: "100%" }}
                                onClick={() => {
                                    onSaveImage();
                                    setEditModeManagerImage(false);
                                }}
                            >
                                {Strings.update}
                            </Button>
                        </Col>
                    </Row>
                ) : (
                    <Col span={24}>
                        <Button style={{ width: "100%" }} onClick={() => setEditModeManagerImage(true)}>
                            {Strings.edit}
                        </Button>
                    </Col>
                )}
            </Row>
        </Space>
    );
}

export default RentImageViewer;
